
import ImageHeader from "@/components/core/ImageHeader";
import locationModal from "@/components/modals/locationModal.vue";
import PlaceCard from "@/components/PlaceCard";
import CategoryCard from "@/components/CategorySection/CategoryCard";
import CategoryFilter from "@/components/CategorySection/CategoryFilter";
import tableLoading from "@/components/tableLoading";
import NoContent from "@/components/customer-content/NoContent";
export default {
  scrollToTop: true,
  components: {
    CategoryFilter,
    ImageHeader,
    locationModal,
    tableLoading,
    PlaceCard,
    CategoryCard,
    NoContent,
  },
  head() {
    return {
      title: this.title,
      meta: [{
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: "Goa, Goa Tourism, Travel Guide, Watersports, Goa Beaches, Romantic Places, Waterfalls, Hidden Places, Must Visit places in Goa, Dudhsagar Waterfalls, Calangute Beach, Palolem Beach, Grand Island Goa, Old Goa Church, Bom Jesus Church, Visit goa, Things to do in Goa, Travel Agency",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: this.description,
        },
        { hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.title ? this.title : 'Goa App'
        },
        { hid: 'og:image',
          property: 'og:image',
          content: this.$config.siteUrl + '/img/meta-imgs/places-meta-image.webp'
        },
        { hid: 'image',
          property: 'image',
          content: this.$config.siteUrl + '/img/meta-imgs/places-meta-image.webp'
        },
        { hid: 'twitter-image',
          property: 'twitter:image',
          content: this.$config.siteUrl + '/img/meta-imgs/places-meta-image.webp'
        },
      ],
    };
  },

  jsonld() {
    return this.getJsonData()
  },

  data() {
    return {
      title: "Must Visit Places in Goa | Beaches, Churches, Waterfalls & more",
      description: "Goa App | Discover Beaches, Churches, Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals in Goa.",
      selectedValue: null,
      search: "",
      isSearchClicked: false,
      pageData: {
        categories: null,
        attractions: null,
        featuredCategories: null,
        placesCategories: null,
        activities: null,
      },
      filters: {
        categories: [],
        allCategory: true,
        sortBy: "popular",
      },
      applyFilterClicked: false,
      skip: 0,
      page: 0,
      totalNumberOfpages: 0,
      listings: {},
      schemaData: [],
      loading: true,
      listingLoading: true,
      placesLoading: true,
      categoriesLoading: true,
      selectedFilter: -1,

      interLinks: {
        "title": "Explore More on Goa App",
        "links": [
          {"sub_title":"Best Places to Visit in Goa",
          "interLinks":[
          {
            "name":"Best Beaches in Goa",
            "url":"/goa/beaches"
          },
	 {
            "name":"Must-Visit Forts in Goa",
            "url":"/goa/forts"
          },
          {
            "name":"Top Waterfalls in Goa",
            "url":"/goa/waterfalls"
          },
          {
            "name":"Historical Places in Goa",
            "url":"/goa/religious-places"
          },
          {
            "name":"Enjoy Best Nightlife in Goa",
            "url":"/goa/nightlife"
          },
          {
            "name":"Roam Goa Villages",
            "url":"/goa/villages"
          },

          ]},
          {"sub_title":"Must Try popular attractions",
          "interLinks":[{
            "name":"WaterSports Booking in Goa",
            "url":"/goa/activities/category/water-sports"
          },
          {
            "name":"Casino Tickets in Goa",
            "url":"/goa/activities/category/entertainment"
          },
          {
            "name":"Book Scuba Diving in Goa",
            "url":"/activities/scuba-diving-at-grande-island-and-water-sports-combo"
          },
          {
            "name":"Book Dudhsagar Waterfall Trek in Goa",
            "url":"/activities/dudhsagar-falls-tour-package"
          },
          {
            "name":"Offers at Best Restaurants in Goa",
            "url":"/offers"
          },
          {
            "name":"Music Events",
            "url":"/events/music-events"
          },
          ]},

          {"sub_title":"More on Goa App",
          "interLinks":[{
            "name":"Hire a Taxi",
            "url":"/taxi"
          },
          {
            "name":"Rent a Car",
            "url":"/rentals"
          },
          {
            "name":"Activities in Goa",
            "url":"activities"
          },

          {
            "name":"Holiday Packages",
            "url":"/packages"
          },


          ]}
        ]
      },

      deviceLoc: null,
      maploaded: false,
      infoWindow: {
        position: {
          lat: 0,
          lng: 0,
        },
        open: false,
        template: "",
      },
      currentLocation: {},
      locationsVisibleOnMap: "",
      locations: [],
      pins: {
        selected: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjA4NCAxMy44MTE5QzE1LjAyNDQgMTIuODE4MyAxNS42NTMgMTEuNTcwOSAxNS44OTIyIDEwLjIyMzlDMTYuMTMxNCA4Ljg3NjkyIDE1Ljk3MDYgNy40ODkzMiAxNS40Mjk3IDYuMjMyN0MxNC44ODg4IDQuOTc2MDggMTMuOTkxNiAzLjkwNTUgMTIuODQ4OSAzLjE1MzI4QzExLjcwNjIgMi40MDEwNSAxMC4zNjgxIDIuMDAwMTcgOSAyLjAwMDE3QzcuNjMxOSAyLjAwMDE3IDYuMjkzODQgMi40MDEwNSA1LjE1MTEyIDMuMTUzMjhDNC4wMDg0MSAzLjkwNTUgMy4xMTExNyA0Ljk3NjA4IDIuNTcwMyA2LjIzMjdDMi4wMjk0MyA3LjQ4OTMyIDEuODY4NjMgOC44NzY5MiAyLjEwNzggMTAuMjIzOUMyLjM0Njk2IDExLjU3MDkgMi45NzU2IDEyLjgxODMgMy45MTYgMTMuODExOUM0LjQ1NTY3IDEyLjk1MDcgNS4yMDUzNiAxMi4yNDA5IDYuMDk0NjcgMTEuNzQ5QzYuOTgzOTggMTEuMjU3MSA3Ljk4MzcgMTAuOTk5MyA5IDEwLjk5OTlDMTAuMDE2MyAxMC45OTkzIDExLjAxNiAxMS4yNTcxIDExLjkwNTMgMTEuNzQ5QzEyLjc5NDYgMTIuMjQwOSAxMy41NDQzIDEyLjk1MDcgMTQuMDg0IDEzLjgxMTlaTTkgMjEuNzI3OUwyLjYzNiAxNS4zNjM5QzEuMzc3MzQgMTQuMTA1MiAwLjUyMDE4OSAxMi41MDE2IDAuMTcyOTI5IDEwLjc1NTdDLTAuMTc0MzMxIDkuMDA5OTIgMC4wMDM5MDkwNSA3LjIwMDM1IDAuNjg1MDk5IDUuNTU1ODJDMS4zNjYyOSAzLjkxMTI5IDIuNTE5ODQgMi41MDU2OSAzLjk5OTg4IDEuNTE2NzZDNS40Nzk5MiAwLjUyNzgzIDcuMjIgMCA5IDBDMTAuNzggMCAxMi41MjAxIDAuNTI3ODMgMTQuMDAwMSAxLjUxNjc2QzE1LjQ4MDIgMi41MDU2OSAxNi42MzM3IDMuOTExMjkgMTcuMzE0OSA1LjU1NTgyQzE3Ljk5NjEgNy4yMDAzNSAxOC4xNzQzIDkuMDA5OTIgMTcuODI3MSAxMC43NTU3QzE3LjQ3OTggMTIuNTAxNiAxNi42MjI3IDE0LjEwNTIgMTUuMzY0IDE1LjM2MzlMOSAyMS43Mjc5Wk05IDkuOTk5OTJDOC4yMDQ0IDkuOTk5OTIgNy40NDEzIDkuNjgzODIgNi44Nzg2OCA5LjEyMTIyQzYuMzE2MDcgOC41NTg2MiA2IDcuNzk1NTcgNiA2Ljk5OTkyQzYgNi4yMDQyNyA2LjMxNjA3IDUuNDQxMjEgNi44Nzg2OCA0Ljg3ODZDNy40NDEzIDQuMzE1OTkgOC4yMDQ0IDMuOTk5OTIgOSAzLjk5OTkyQzkuNzk1NyAzLjk5OTkyIDEwLjU1ODcgNC4zMTU5OSAxMS4xMjEzIDQuODc4NkMxMS42ODM5IDUuNDQxMjEgMTIgNi4yMDQyNyAxMiA2Ljk5OTkyQzEyIDcuNzk1NTcgMTEuNjgzOSA4LjU1ODYyIDExLjEyMTMgOS4xMjEyMkMxMC41NTg3IDkuNjgzODIgOS43OTU3IDkuOTk5OTIgOSA5Ljk5OTkyWiIgZmlsbD0iIzBGMjE0RiIvPgo8L3N2Zz4K",
        notSelected: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABHElEQVR42uVVyw4BMRQdC98lsbPwG5YSH+BzWFtLZilh0oQgFh6J54IwBmGYtrfaBREdcTvDhpM0adrec3rb+7Csn8fRdrLg7VzBubhDzmHrudRuZ2KRs/miLd6AThfNaOTTGRFIsMm8bkSuXBeGoLVaGi0g39wLI4GTf1EjdE/+E1pAAGgEAenkb/tBo1vQFUDgBbSbny6al77uSQwB/6wJSNHoAo8xj30iaYMW4Lv9wfSTpc0eH6atXtE4TKWNUS4AY2hyddY4k/lwVEZncm9QilQuBGPwnp1B5GIXGi3P0eU0c7EqKrje5hU5d7fr2P2AEJIESkNqB1XJkvhI0/GrTuqZX619tLMF/VHlfnk5/0r7ZMvVWA3rr3AF6LIMZ7PmSlUAAAAASUVORK5CYII=",
      },
      mapStyle: [{
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [{
            color: "#ffffff",
          }, ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [{
              visibility: "on",
            },
            {
              color: "#3e606f",
            },
            {
              weight: 2,
            },
            {
              gamma: 0.84,
            },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{
            visibility: "off",
          }, ],
        },
      ],
      slickOptions: {
        slidesToShow: 6,
        arrows: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        swipe: true,
        mobileFirst: true,
        touchMove: true,
        waitForAnimate: true,
        focusOnChange: true,
        cssEase: 'ease',
        easing: 'linear',
        useCSS: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 4.2,
              slidesToScroll: 1,
              infinite: false,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1,
              infinite: false,
            }
          }, {
            breakpoint: 575,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 1,
              infinite: false,
            }
          }, {
            breakpoint: 375,
            settings: {
              slidesToShow: 2.1,
              slidesToScroll: 1,
              infinite: false,
            }
          }

        ]
      }
    };
  },
  fetchOnServer: false,

  async fetch() {

    this.pageData.featuredCategories = await fetch(
      this.$config.fetchUrl +
      "/api/activityCategories/app/getFeaturedCategories"
    ).then((res) => res.text());
    this.pageData.featuredCategories = this.getCryptKey(this.pageData.featuredCategories);
    this.categoriesLoading = false;

    this.pageData.attractions = await fetch(this.$config.fetchUrl + '/api/attractions/getAttractions').then(res => res
      .text());
      this.pageData.attractions = this.getCryptKey(this.pageData.attractions);
    //Get the list of page data
    this.pageData.categories = await fetch(
      this.$config.fetchUrl + "/api/activityTypes/app/getTypeDetails/places"
    ).then((res) => res.text());
    this.pageData.categories = this.getCryptKey(this.pageData.categories);
    this.placesLoading = false;

    //sort data for json ld schema
    if(this.pageData.attractions && this.pageData.attractions.length > 0){
      let result = this.pageData.attractions.map(a => a.posts);
      if(result && result.length > 0){
        this.schemaData = result.flat();
        this.schemaData.filter((v,i,a)=>a.findIndex(v2=>(v._id === v2._id))===i)
      }
    }

  },

  mounted() {
    document.body.classList.add("modalOverflow");
    if (localStorage.getItem("plcData")) {
      localStorage.removeItem('plcData');
    }

    if (localStorage.getItem('placesFilter')) {
      localStorage.removeItem('placesFilter');
    }

    // var locDets = null;
    // if (!localStorage.getItem("loc")) {
    //   setTimeout(() => {
    //     document.getElementById("openLoc").click();
    //   }, 3000);
    // } else {
    //   locDets = JSON.parse(localStorage.getItem("loc"));
    //   if (locDets.permissionGranted) {
    //     this.deviceLoc = locDets.locationDets;
    //     this.requestLoc();
    //   }
    // }

    let searchedCategory = this.$route.query.category ?
      this.$route.query.category :
      null;
    var self = this;
    if (searchedCategory) {
      if (Array.isArray(searchedCategory)) {
        searchedCategory.forEach(function(value, index) {
          self.filters.categories.push(value);
        });
      } else {
        this.filters.categories.push(searchedCategory);
      }
      this.filters.allCategory = false;
    }

    this.restoreFilters();
    let pagination = (this.page - 1) * 12;
    if (pagination < 0) {
      pagination = 0;
    }

    // this.getListings(
    //   pagination,
    //   this.search,
    //   this.filters.sortBy,
    //   this.filters.categories
    // );
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove("modalOverflow");
    if (document.getElementById("filterClose"))
      document.getElementById("filterClose").click();
    if (document.getElementById("locationClose"))
      document.getElementById("locationClose").click();
  },

  computed: {
    disableSearch() {
      let searchStr = "";
      if (this.search) searchStr = this.search.trim();
      const re = /^[a-zA-Z0-9\s,-]{3,}/;
      return re.test(String(searchStr).toLowerCase());
    },
  },

  methods: {
    getDistanceFromLatLonInKm(location) {
      if (
        this.deviceLoc &&
        this.deviceLoc.lat &&
        location &&
        location.latitude
      ) {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(location.latitude - this.deviceLoc.lat); // deg2rad below
        var dLon = this.deg2rad(location.longitude - this.deviceLoc.long);
        var a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(this.deg2rad(this.deviceLoc.lat)) *
          Math.cos(this.deg2rad(location.latitude)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return Math.round(d * 100) / 100;
      } else return "";
    },
    getJsonData() {
      let structure = {
        "@context": "http://schema.org"
      }
      let data = this.schemaData.map((itm, index) => ({
        "@type": "LocalBusiness",
        "name": itm.title ? itm.title : 'Goa App',
        "image": itm.gallery ? itm.gallery : [],
        "geo": {
          "@type": "GeoCoordinates",
          "latitude":itm.location ? itm.location.latitude : '',
          "longitude": itm.location ? itm.location.longitude : ''
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress":  itm.location ? itm.location.address : '',
          "addressLocality": "Goa",
          "postalCode": "403001",
          "addressCountry": "IN"
        },
        priceRange: '',
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue":  itm.rating ? itm.rating.averageRating : '5',
            "bestRating": itm.rating ? itm.rating.averageRating : '5',
          },
          "author": {
            "@type": "Person",
            "name": "GoaApp"
          }
        },
        "review": [{
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": 5
          },
          "author": {
            "@type": "Person",
            "name": "Sanjeet Shet"
          }
        },
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": 4
          },
          "author": {
            "@type": "Person",
            "name": "Diptesh Kamat"
          }
      }],
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "138",
          "ratingCount": "89",
          "ratingValue": itm.rating ? itm.rating.averageRating : '76'
        },
      }))
      return {
        ...structure,
        ...data
      };
    },

    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },

    setInStorage(toStore, locDet = null) {
      let store = {
        permissionGranted: toStore,
        locationDets: locDet,
      };
      localStorage.setItem("loc", JSON.stringify(store));
    },
    requestLoc() {
      var self = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            var coords = {
              lat: position.coords.latitude,
              long: position.coords.longitude,
            };
            self.deviceLoc = coords;
            self.getNearByPlaces();
            self.setInStorage(true, coords);
          },
          function(error) {
            if (error.code == error.PERMISSION_DENIED) self.setInStorage(false);
          }
        );
      }
    },

    coordsDets(value) {
      this.deviceLoc = value;
      this.getNearByPlaces();
    },

    checkForMarkers() {
      this.locations.forEach((location, i) => {
        location.visible = this.$refs.gMap.map
          .getBounds()
          .contains(this.$refs.gMap.markers[i].getPosition());
      });

      this.locationsVisibleOnMap = this.locations
        .filter((l) => l.visible)
        .map((l) => l.name)
        .join(", ");
    },

    openOne(event) {
      this.$router.push({
        path: "/places/" + event,
      });
    },

    categoryChecked(id) {
      return this.filters.categories.includes(id);
    },

    getCatTitles() {
      var titles = "All Places";
      if (this.filters.categories.length < 1) {
        return "All Places";
      } else if (
        this.pageData &&
        this.pageData.categories &&
        this.pageData.categories.categories &&
        this.pageData.categories.categories.length > 0
      ) {
        if (
          this.pageData.categories.categories.length ==
          this.filters.categories.length
        ) {
          return "All Places";
        } else {
          titles = this.pageData.categories.categories.filter((a) =>
            this.filters.categories.some((b) => a._id === b)
          );
          var names = titles.map(function(item) {
            return item["name"];
          });
          return names.join(", ");
        }
      } else return "All Places";
    },

    // Store filters in Localstorage
    restoreFilters() {
      let filters = null;
      if (localStorage.getItem("placesFilter")) {
        filters = JSON.parse(localStorage.getItem("placesFilter"));
        this.search = filters.search;
        this.filters.sortBy = filters.sortBy;
        this.filters.categories = filters.categories;

        if (filters.categories.length > 0) {
          this.filters.allCategory = false;
        }
        this.page = filters.page;
      }
    },

    // Store filters in Localstorage
    storeFilters() {
      let filters = {
        search: this.search,
        sortBy: this.filters.sortBy,
        page: this.page,
        categories: this.filters.categories,
      };
      localStorage.setItem("placesFilter", JSON.stringify(filters));
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return "";
      }
    },
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`);
    },

    categoryAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
    },
    // callback for the pagination plugin
    callback: function(page) {
      this.page = page;
      this.storeFilters();
      let pagination = (page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      //this.scrollToElement('listing-list');
      if (
        (this.search && this.isSearchClicked) ||
        (this.filters.sortBy && this.filters.sortBy != "popular") ||
        (this.filters.categories && this.filters.categories.length > 0)
      ) {
        this.getListings(
          pagination,
          this.search,
          this.filters.sortBy,
          this.filters.categories
        );
      } else {
        this.getListings(pagination);
      }
    },

    filterLocations() {
      if (
        this.deviceLoc &&
        this.deviceLoc.long &&
        this.listings &&
        this.listings.posts
      ) {
        var self = this;
        this.listings.posts = this.listings.posts.map((v) => ({
          ...v,
          locDistace: self.getDistanceFromLatLonInKm(v.post.location),
        }));
        this.listings.posts.sort((a, b) => a.locDistace - b.locDistace);
      }
    },

    getNearByPlaces() {
      this.maploaded = false;
      var formData = new URLSearchParams();
      formData.append("latitude", this.deviceLoc.lat);
      formData.append("longitude", this.deviceLoc.long);

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // AXIOS api call to add review api
      this.$axios
        .post("/api/posts/app/getNearbyPostsForMap/places", formData, {
          headers: headers,
        })
        .then((response) => {
          let value = this.getCryptKey(response.data);
          if (value.length > 0) {
            var arr2 = value.map((v) => ({
              name: v.title,
              slug: v.slug,
              lat: v.location.latitude,
              lng: v.location.longitude,
              icon: {
                url: v.thumbnail,
                scaledSize: {
                  width: 50,
                  height: 50,
                },
                labelOrigin: {
                  x: 16,
                  y: -10,
                },
              },
            }));
            this.locations = arr2;
            this.maploaded = true;
            //this.filterLocations();
          }
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.maploaded = false;
          });
        });
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, queryStr = null, sortBy = null, categories = null) {
      //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
      //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
      //iF categories array pass the array in params
      //var arrStr = encodeURIComponent(JSON.stringify(this.filters.categories));

      this.listingLoading = true;
      var formData = new URLSearchParams();
      formData.append("skip", skip);
      if (queryStr) formData.append("query", queryStr.trim());
      if (sortBy) formData.append("sortBy", sortBy.trim());
      if (categories != null && categories.length > 0) {
        categories.forEach((category) => {
          formData.append("categories", category);
        });
      }
      if (categories != null && categories.length > 0) {
        categories = encodeURIComponent(JSON.stringify(categories));
      } else {
        categories = ["all"];
      }

      var query = "search";

      if (queryStr) {
        query = queryStr.trim();
      }

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // AXIOS api call to add review api
      this.$axios
        .get(
          `/api/posts/app/getPostsOfType/places/${query}/${skip}/${categories}/${sortBy ? sortBy : "popular"
          }`
        )
        .then((response) => {
          this.applyFilterClicked = false;
          if (queryStr) this.isSearchClicked = true;
          let value = this.getCryptKey(response.data);
          this.listings = value;
          this.schemaData = this.listings && this.listings.posts ? this.listings.posts : [];
          //this.filterLocations();
          if (skip == 0) {
            this.page = 0;
          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          document.getElementById("filterClose").click();
          this.$nextTick(() => {
            this.scrollToSectionIntoView("listing-card");
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        });
    },

    // Hide/Show clear Button
    showClearBtn() {
      if (
        (this.search && this.isSearchClicked) ||
        (this.filters.sortBy && this.filters.sortBy != "popular") ||
        (!this.filters.allCategory && this.filters.categories.length > 0)
      )
        return true;
      return false;
    },

    // Clear all dates, search and filters on click
    clearAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
      this.filters.sortBy = "popular";
      this.search = "";
      this.isSearchClicked = false;
    },
  },
};
